import { Zap } from "lucide-react"
import { cn } from "@/lib/utils"
import { Button } from "../Button/Button"
import type { UpgradeMessage } from "../types/chat"

export interface ChatMessageUpgradeProps {
  message: UpgradeMessage
  onUpgrade?: () => void
  ctaLabel?: string
  className?: string
}

export function ChatMessageUpgrade({
  message,
  onUpgrade,
  ctaLabel = "Upgrade",
  className,
}: ChatMessageUpgradeProps) {
  return (
    <div
      className={cn(
        "rounded-md border border-warning/30 bg-warning/5 px-3 py-3 flex items-start gap-2.5",
        className,
      )}
    >
      <Zap
        size={14}
        strokeWidth={1.75}
        className="text-warning shrink-0 mt-0.5"
        aria-hidden="true"
      />
      <div className="flex-1 min-w-0">
        <p className="text-body text-foreground">{message.content}</p>
        <Button
          size="sm"
          className="mt-2.5 h-7 text-label bg-warning text-background hover:bg-warning/90"
          onClick={onUpgrade}
        >
          {ctaLabel}
        </Button>
      </div>
    </div>
  )
}
